import { handleActions } from "redux-actions";
import { createRoutine } from "redux-saga-routines";

export const fetchStaticPageRedirectsRoutine = createRoutine(
  "app/staticPageRedirects/FETCH"
);

export const initialState = {
  byLocale: {},
  loading: false
};

export default handleActions(
  {
    [fetchStaticPageRedirectsRoutine.TRIGGER]: state => ({
      ...state,
      loading: true
    }),
    [fetchStaticPageRedirectsRoutine.SUCCESS]: (state, { payload }) => ({
      ...state,
      loading: false,
      byLocale: {
        ...state.byLocale,
        [payload.locale]: payload.mappings
      }
    }),
    [fetchStaticPageRedirectsRoutine.FAILURE]: state => ({
      ...state,
      loading: false
    })
  },
  initialState
);
